<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div [ngClass]="{'page-content-title': useRebrandedLayout }" [innerHTML]="termsAndConditions"></div>
</div>